import "./services.css";
import { useState, useEffect } from "react";

const titles = ["Gestión integral de proyectos", "Proyecto y construcción de obras civiles", "Servicios de consultoría", "Administración de activos"];

const detailsArr = [
    [   
        "Interpretación de los requisitos del cliente",
        "Realización de anteproyectos y confección de especificaciones técnicas",
        "Definición de alcance, tiempos estimado y costos.",
        "Administración de contratos",
        "Seguimiento, control y certificacion de avance",
        "Aseguramiento de la calidad contratada",
    ],
    [
        "Demoliciones, excavaciones y submuraciones",
        "Obras de pequeña y mediana envergadura",
        "Redes de agua, cloaca y pluviales",
        "Estructuras metálicas",
    ],
    [
        "Gestión ambiental",
        "Gestión de calidad",
        "Gestión de inversiones",
        "Ingeniería hidráulica",
    ],
    [
        "Mantenimiento de parques y jardines",
        "Mantenimiento edilicio",
        "Mantenimiento de instalaciones operativas",
        "Gestión de espacios de trabajo en oficinas y atención al público"
    ]
];

const CardTitle = (props: { title: string, index: number, showDetail: (index: number) => void}) => {
    return (
        <div className="servicesCardCont flex column" onClick={() => props.showDetail(props.index)}>
            <p className="servicesCardText">{props.title}</p>
        </div>
    );
};

const CardDetail = (props: {detail: string[], title: string, closeDetail: (index: number) => void, index: number, containerClass?: string[], bgClass: string}) => {

    useEffect(() => {
        const close = (e: MouseEvent) => {
            const target = e.target as HTMLElement;
            if (!target.getAttribute("class")?.includes("servicesDetailCont")) {
                props.closeDetail(props.index);
                window.removeEventListener("click", close);
            }
        };
              
        const cardDetailAnimation = document.querySelector(".servicesDetailCont")?.getAnimations()[0];
        cardDetailAnimation?.addEventListener("finish", () => {
            window.addEventListener("click", close);
        });

        return () => window.removeEventListener("click", close);
    }, [props]);
    
    return (
        <>
            <div className={`servicesDetailCont flex column ${props.containerClass?.join(" ") || ""}`}>
                <img src="/images/icons/close.png" className="servicesDetailCloseIcon" onClick={() => props.closeDetail(props.index)} alt="Cerrar"/>
                <h2 className="servicesDetailTitle">{props.title}</h2>
                <div className="servicesDetailTextCont flex column">
                    {
                        props.detail.map((detailText, index) =>
                            <div className="servicesDetailTextCont2 flex" key={index}>
                                <img src="/images/icons/bullet.png" alt="Viñeta" className="servicesDetailTextBullet"/>
                                <p className="servicesDetailText">{detailText}</p>
                            </div>
                        )
                    }
                </div>
            </div>
            <div className={`servicesDetailBg ${props.bgClass}`}></div>        
        </>
    );
};

function Services() {

    const [detail, setDetail] = useState(<></>);
    const navBarWidth = window.innerWidth > window.innerHeight ? "80%" : "100%";                                     //Tiene que coincidir con el "width" de "contMenu" en el CSS
    
    const closeDetail = (index: number) => {
        setDetail(<CardDetail detail={detailsArr[index]} title={titles[index]} closeDetail={closeDetail} index={index} containerClass={["servicesDetailContAnimationReverse"]} bgClass="servicesDetailBgAnimationReverse"/>);
        document.body.style.overflow = "initial"; 
        document.body.style.paddingRight = "0";
        const contMenu = document.querySelector(".contMenu") as HTMLDivElement;
        contMenu.style.width = navBarWidth;
    };

    const showDetail = (index: number) => {
        setDetail(<CardDetail detail={detailsArr[index]} title={titles[index]} closeDetail={closeDetail} index={index} containerClass={["servicesDetailContAnimation"]} bgClass="servicesDetailBgAnimation"/>);
        if (window.innerWidth !== document.body.offsetWidth) {     //Si hay barra de scroll..
            document.body.style.overflow = "hidden";
            document.body.style.paddingRight = "17px";
            const contMenu = document.querySelector(".contMenu") as HTMLDivElement;
            contMenu.style.width = `calc(${navBarWidth} - 14px)`;
        }
    };

    useEffect(() => {
        const cardDetail = document.querySelector(".servicesDetailCont") as HTMLDivElement;             
        if (!cardDetail) return;
        if (cardDetail.getAttribute("class")?.includes("servicesDetailContAnimationReverse")) {
            const cardDetailAnimation = cardDetail.getAnimations()[0];
            cardDetailAnimation?.addEventListener("finish", () => {
                setDetail(<></>);                                                                           //Al finalizar la animación de cerrado de la card de detalle limpiamos "detail"
            });
        }
    }, [detail]);
        
    return (
        <div className="servicesCont flex wrap" id="servicios">
            {titles.map((title, index) => <CardTitle title={title} index={index} key={index} showDetail={showDetail} />)}
            {detail}
        </div>
    );
}

export default Services;